const PANEL_POSITIONS = ['left', 'bottom', 'default', 'center'];

export { PANEL_POSITIONS };
